<script setup>
import Navbar from '@/Layouts/Partials/Navbar.vue'
import Footer from '@/Layouts/Partials/Footer.vue'
import ScrollUp from '@/Layouts/Partials/ScrollUp.vue'

const props = defineProps({
    title: {
        type: String,
        required: false,
        default: '',
    },

    description: {
        type: String,
        required: false,
        default: '',
    },
})
</script>

<template>
    <Head>
        <title>{{ title }}</title>
        <meta
            name="description"
            :content="description"
        />
    </Head>

    <Navbar />

    <main class="relative min-h-screen">
        <slot name="content" />

        <ScrollUp />
    </main>

    <Footer />
</template>
